// src/pages/ProgrammesPage.js

import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import "../Style/Programmes.css";
import "../Style/Responsive.css";
import ChatBot from "./Chatbot";
import { formatDescription } from '../utils/formatDescription';

import KPMGExecutive from "../Images/optimized/KPMG Executive Masterclass.webp";
import KPMGStrategic from "../Images/optimized/KPMG exec Masterclass.webp";
import leader from "../Images/optimized/leadership-leader.webp";
import {
  FaArrowRight,
} from 'react-icons/fa';

// Program category icons
import kpmgMasterIcon from "../icons/KPMGMasterPrograms-icon.png";
import externalProgramsIcon from "../icons/ExternalPrograms-icon.png";
import mentorshipIcon from "../icons/Mentorship&FounderSessions-icon.png";
import pitchCoachingIcon from "../icons/PitchCoaching-icon.png";

// Modal contact icons
import locationIcon from "../icons/location&address-icon.png";
import mailIcon from "../icons/mail-icon.png";

// New master class images (compressed .webp variants from optimized/)
import marketImg from "../Images/optimized/market-access.webp";
import financeImg from "../Images/optimized/financial-management.webp";
import strategicImg from "../Images/optimized/strategic-management.webp";
import advancedtax from "../Images/optimized/Advanced Tax Strategies.webp";
import taxImg from "../Images/optimized/regulatory-tax.webp";
import workforceImg from "../Images/optimized/workforce-management.webp";
import techImg from "../Images/optimized/business-technology.webp";
import opsImg from "../Images/optimized/operations-management.webp";
import govImg from "../Images/optimized/governance.webp";
import digtrans from "../Images/optimized/Digital Tax Transformation.webp";
import funtax from "../Images/optimized/Fundamentals of Taxation.webp";
import taxtech from "../Images/optimized/Tax Tech Bootcamp.webp";
import kpmgacademy from "../Images/optimized/CPE-Training-kpmg academy.webp";
import strathmorefamilybiz from "../Images/optimized/strathmore-familybiz.webp";

// Tech Innovator Section with images instead of videos
import GTI from "../Images/optimized/GTI.webp";
import antlerLogo from "../antler-logo-red.svg";


function ProgrammesPage() {
  const { t } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [modalContent, setModalContent] = useState(null);

  const categories = [
    {
      id: 'kpmg-master',
      title: 'KPMG Master Programs',
      tagline: 'Premier KPMG-led training across business disciplines.',
      icon: kpmgMasterIcon,
      accent: '#00338D',
      paid: true,
    },
    {
      id: 'external-programs',
      title: 'External Programs',
      tagline: 'Curated partner programs across the African ecosystem.',
      icon: externalProgramsIcon,
      accent: '#7213EA',
      paid: true,
      subCategories: [
        { id: 'ecosystem-programs', title: 'Ecosystem Programs' },
        { id: 'family-business-programs', title: 'Family Business Programs' },
      ],
    },
    {
      id: 'mentorship',
      title: 'Mentorship & Founder Sessions',
      tagline: '1:1 guidance from seasoned founders, advisors and operators.',
      icon: mentorshipIcon,
      accent: '#FD349C',
      paid: true,
    },
    {
      id: 'pitching',
      title: 'Pitch Coaching',
      tagline: 'Sharpen your story and present with confidence to investors.',
      icon: pitchCoachingIcon,
      accent: '#00C0AE',
      paid: true,
    },
  ];

  const STATS = [
    { value: '21+', label: 'Programs available' },
    { value: '4', label: 'Program tracks' },
    { value: 'Pan-African', label: 'Reach' },
    { value: 'KPMG-led', label: 'Curation & advisory' },
  ];

  const programmesData = [
    // --- Existing Paid KPMG Masterclasses ---
      {
      title: 'KPMG Learning Academy',
      provider: 'KPMG',
      description: [
        "The KPMG Learning Academy combines an extensive amount of subject matter expertise with a number of tried and tested training programmes.",
        "We provide diverse educational and training programmes which include professional accounting and financial training, postgrad and undergraduate degrees.",
        
      "KPMG Learning Academy is licensed as a Further and Higher Education Institution (License number: 2017 – 010) by the Malta Further & Higher Education Authority."
    ],

      link: 'https://kpmglearningmalta.com/',
      image: kpmgacademy,
      category: 'kpmg-master',
    },
    {
      title: 'KPMG Executive Masterclass',
      provider: 'KPMG',
      description: 'A premium programme tailored for business executives.',
      image: KPMGExecutive,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'KPMG Strategic Master Programme',
      provider: 'KPMG',
      description: 'A comprehensive programme focusing on strategic business growth.',
      image: KPMGStrategic,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'KPMG Leadership Master Programme',
      provider: 'KPMG',
      description: 'Develop leadership skills with our industry experts.',
      image: leader,
      category: 'kpmg-master',
      price: '$395'
    },
    // --- NEW Master Classes ---
    {
      title: 'Access to Market',
      provider: 'KPMG',
      description: `Equip yourself to position products globally: build your marketing plan, 
       leverage e-commerce and CRM, and launch structured export strategies.`,
      image: marketImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'Financial Management',
      provider: 'KPMG',
      description: `Master budgeting, cash management, forecasting, credit control and 
financial reporting to drive informed decisions.`,
      image: financeImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'Strategic Management',
      provider: 'KPMG',
      description: `Learn vision & mission crafting, SWOT and competitive analysis,
plus strategic sourcing & procurement optimization.`,
      image: strategicImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'Regulatory & Tax Compliance',
      provider: 'KPMG',
      description: `Navigate Ghana’s GRA & SSNIT obligations and build a robust compliance framework.`,
      image: taxImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'Workforce Management',
      provider: 'KPMG',
      description: `From recruitment to performance appraisals and legal compliance,
create HR systems that foster growth.`,
      image: workforceImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'Operations Management',
      provider: 'KPMG',
      description: `Apply due diligence, rapid assessments and Kaizen to streamline operations 
and boost productivity.`,
      image: opsImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
      title: 'Governance',
      provider: 'KPMG',
      description: `Understand board structures, ethical leadership, ESG integration and CSR strategies 
for sustainable success.`,
      image: govImg,
      category: 'kpmg-master',
      price: '$395'
    },
    {
  title: 'Business Technology & Implementation',
  provider: 'KPMG',
  description: `Practical, hands-on training to modernize your business stack:
- IT fundamentals for non-IT teams (governance, policies, risk)
- Implementing core processes (IDAM, backups, DR, change control)
- ERP/CRM selection & rollout basics
- Automation with low-code/RPA and workflow tools
- Data management & analytics foundations
- Cyber hygiene and data privacy by design
- Social, collaboration, and AI tools for productivity
By the end, you’ll map current processes, design a target operating model, and ship a 90-day implementation plan.`,
  image: techImg,
  category: 'kpmg-master',
  price: '$395'
},
{
  title: 'Tax Technology & GenAI Adoption',
  provider: 'KPMG',
  description: `Train your tax & finance teams to deliver a digitized, data-driven tax function:
- End-to-end tax process mapping (direct, indirect, payroll)
- Automation of compliance workflows (extractions, validations, filings)
- VAT/PAYE/WHT use cases with analytics & dashboards
- Data quality, controls, and audit trails across ERP
- E-invoicing, digital reporting, and authority integrations
- GenAI for tax research, document review, and reconciliation assistance
- Operating model, roadmap, and change management
Capstone: build a live prototype (automation + dashboard) and a 6-month tax-transformation roadmap.`,
  image: taxtech,
  category: 'kpmg-master',
  price: '$200'
},
    // --- Free & Mentorship & Pitching ---
    {
      title: 'Antler Global Founder Program',
      provider: 'Antler',
      description: 'Launch your startup with support from a global community of entrepreneurs and investors.',
      link: 'https://www.antler.co',
      image: antlerLogo,
       category: 'ecosystem-programs',
    },
      {
      title: 'Launch Africa Accelerator',
      provider: 'Launch Africa',
      description: 'Launch your startup with support from a global community of entrepreneurs and investors.',
      link: 'https://www.launchafrica.vc/',
      image: kpmgacademy,
      category:  'ecosystem-programs'
    },

    //Mentorship programs
    {
      title: "Startup Founder Mentorship",
      provider: "Ecosystem Partners",
      description:["Receive personalized one-on-one guidance from seasoned entrepreneurs to refine your business strategy, pitch, and growth plan."],
      link: "/payment",
      image: taxtech, 
      category: "mentorship"
    },
    {
      title: "Tech Founder Bootcamp",
      provider: "Ecosystem Partners",
      description:["An intensive bootcamp designed for tech founders to accelerate startup growth through strategic mentorship and peer networking."],
      link: "/payment",
      image: digtrans,
      category: "mentorship"
    },
    {
      title: "Scaling Strategies Mentorship",
      provider: "Ecosystem Partners",
      description: [
        "Learn proven strategies to scale your business from successful founders and industry experts, with tailored mentorship sessions.",
        
      ],
      link: "/payment",
      image: funtax,
      category: "mentorship"
    },

    //Pitching programs
    {
      title: 'Pitch Fundamentals Workshop',
      provider: 'Ecosystem Partners',
      description: [
        "Understanding your audience",
        "Structuring the pitch",
        "Value proposition"
      ],
      link: '/payment',
      image: leader,
      category: 'pitching',
      price: '$395'
    },
      {
      title: 'Elevator Pitch Drills',
      provider:'Ecosystem Partners',
      description: [
        "Crafting a memorable hook",
        "Communicating value in simple terms",
        "Balancing detail vs. brevity"
      ],
      link: '/payment',
      image: advancedtax,
      category: 'pitching',
    }
,
      // — Family Business Programs — Strathmore —
  {
    title: "Family Business Executive Programme",
    provider: "Strathmore University Business School",
    description: [
      "“Familiness” is a resource that can create uniqueness and a critical source of competitive advantage to a business.",
      "Almost all companies start as family businesses, but only those that master the challenges intrinsic to this form of ownership endure growth, maintain collegiality and harmony as a family and achieve success in the business.",
      "In the process, they transition successfully across generations and proceed to prosper and diversify into multi-location and multi-industry businesses.",
      "",
      // now your “key aspects” in bullet form:
      "Succession Planning: navigate leadership & ownership transfer smoothly across generations.",
      "Family Dynamics: address communication, conflict resolution and healthy boundaries.",
      "Leadership Development: build decision-making & management skills tailored to family firms.",
      "Financial Management: optimize planning, investment strategy & risk management.",
      "Governance & Strategy: strengthen board structures and long-term strategic planning."
    ],
    link: "https://sbs.strathmore.edu/programme/family-business-executive-programme/",
    image: strathmorefamilybiz,
    category: "family-business-programs",
  },

  ];

  // Filter programmes based on the selected category and search term
  const activeCategory = selectedSubCategory || selectedCategory;
  const filteredProgrammes = programmesData.filter(
    p =>
      p.category === activeCategory &&
      (p.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
       p.provider.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  

  const openModal = prog => setModalContent(prog);
  const closeModal = () => setModalContent(null);

 // If no category is selected, show the category selection view
  if (!selectedCategory) {
    const innovatorCards = [
      {
        title: "Tech Innovator — East Africa",
        region: "Kenya · Uganda · Tanzania · Rwanda · Ethiopia",
        regionTag: "East Africa",
        status: "closed",
        statusLabel: "Applications closed",
        accent: "#00338D",
        description:
          "Pitch and showcase your tech innovation with KPMG's guidance and a network of global investors. View past finalists and watch this space for the next intake.",
        url: "https://kpmg.com/ke/en/insights/2025/06/kpmg-private-enterprise-tech-innovator-in-east-africa.html",
        ctaLabel: "View past edition",
      },
      {
        title: "Tech Innovator — West Africa",
        region: "Ghana",
        regionTag: "West Africa",
        status: "closed",
        statusLabel: "Applications closed",
        accent: "#7213EA",
        description:
          "Seeking the region's top tech entrepreneurs and visionaries — with insights, mentorship and global recognition. View past edition details below.",
        url: "https://kpmg.com/gh/en/insights/technology-and-innovation/KPMG-Global-Tech-Innovator-Terms-and-Conditions.html",
        ctaLabel: "View past edition",
      },
      {
        title: "Tech Innovator — Southern Africa",
        region: "South Africa",
        regionTag: "Southern Africa",
        status: "closed",
        statusLabel: "Applications closed",
        accent: "#FD349C",
        description:
          "Showcase your cutting-edge solutions and connect with industry leaders and investors driving growth across the region. View past edition for context.",
        url: "https://kpmg.com/za/en/insights/2025/04/global-tech-innovator-2025.html",
        ctaLabel: "View past edition",
      },
    ];

    return (
      <div className="programmes-container">
        <header className="programmes-header">
          <span className="programmes-eyebrow">{t('programs_title')}</span>
          <h1>{t('programs_subtitle')}</h1>
          <p>
            Curated training, mentorship and pitch programs designed for
            founders, investors and ecosystem partners — connecting expertise,
            capital and opportunity across the continent.
          </p>
          <div className="programmes-stats">
            {STATS.map((s) => (
              <div key={s.label} className="programmes-stat">
                <div className="programmes-stat-value">{s.value}</div>
                <div className="programmes-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </header>

        <div className="categories-grid">
          {categories.map((cat) => {
            return (
              <button
                key={cat.id}
                type="button"
                className="category-card"
                style={{ '--accent': cat.accent }}
                onClick={() => {
                  setSelectedCategory(cat.id);
                  setSelectedSubCategory('');
                }}
              >
                <span className="category-card-icon" aria-hidden="true">
                  <img src={cat.icon} alt="" />
                </span>
                <h3>{cat.title}</h3>
                <p className="category-card-tagline">{cat.tagline}</p>
                <span className="category-card-cta">
                  {t('explore')} <FaArrowRight />
                </span>
              </button>
            );
          })}
        </div>

        {/* KPMG Private Enterprise Tech Innovator Section */}
        <section className="tech-innovator-section" id="tech-innovator">
          <header className="tech-innovator-header">
            <span className="programmes-eyebrow">Flagship Competition</span>
            <h2>Global Tech Innovator</h2>
            <p>
              KPMG Private Enterprise's flagship competition for tech founders breaking
              new ground across Africa — connecting them with global mentorship,
              investor networks and recognition.
            </p>
          </header>

          <div className="tech-innovator-container">
            {innovatorCards.map((c) => (
              <div
                key={c.title}
                className="innovator-card"
                style={{ "--accent": c.accent }}
              >
                <div className="innovator-image">
                  <img src={GTI} alt={c.title} loading="lazy" />
                  <span className={`innovator-status status-${c.status}`}>
                    {c.statusLabel}
                  </span>
                </div>
                <div className="innovator-card-body">
                  <span className="innovator-region-chip">
                    <img src={locationIcon} alt="" aria-hidden="true" style={{width:'1em',height:'1em',verticalAlign:'middle'}} /> {c.regionTag}
                  </span>
                  <h3>{c.title}</h3>
                  <p className="innovator-region-detail">{c.region}</p>
                  <p>{c.description}</p>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary"
                  >
                    {c.ctaLabel} <FaArrowRight />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    );
  }

   // 2) External Programs selected, but no sub-category yet → show sub-categories
  const mainCat = categories.find(c => c.id === selectedCategory);
  if (selectedCategory === 'external-programs' && !selectedSubCategory) {
    return (
      <div className="programmes-container">
        <header className="programmes-header">
          <span className="programmes-eyebrow">Programs · External</span>
          <h1>{mainCat.title}</h1>
          <p>Choose a track under External Programs:</p>
          <button
            className="back-button"
            onClick={() => setSelectedCategory('')}
          >
            &larr; Back to Categories
          </button>
        </header>
        <div className="categories-grid">
          {mainCat.subCategories.map((sub) => (
            <button
              key={sub.id}
              type="button"
              className="category-card"
              style={{ '--accent': mainCat.accent }}
              onClick={() => setSelectedSubCategory(sub.id)}
            >
              <span className="category-card-icon" aria-hidden="true">
                <img src={externalProgramsIcon} alt="" />
              </span>
              <h3>{sub.title}</h3>
              <span className="category-card-cta">
                Explore <FaArrowRight />
              </span>
            </button>
          ))}
        </div>
      </div>
    );
  }

    // 3) some other main category, or we've picked our sub-category → show programmes
  // const headerTitle = selectedSubCategory
  //   ? mainCat.subCategories.find(s => s.id === selectedSubCategory).title
  //   : mainCat.title;
  // Programmes list view
  return (
    <div className="programmes-container">
      <header className="programmes-header">
        <span className="programmes-eyebrow">Programs</span>
        <h1>{categories.find(c => c.id === selectedCategory)?.title}</h1>
        <p>Explore our curated programmes for {categories.find(c => c.id === selectedCategory)?.title}. Subject-matter experts in these areas will facilitate the training sessions using modern collaborative teaching methods to encourage active participation among the participants. Startups will get comprehensive support to refine and present their business ideas to investors, including pitch coaching and storytelling techniques.</p>
        <button
          className="back-button"
          onClick={() => { setSelectedCategory(''); setSearchTerm(''); }}
        >
          ← Back to Categories
        </button>
        <div className="search-bar">
          <input
            type="text"
            placeholder={t('search_placeholder')}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </header>

      <div className="programmes-grid">
        {filteredProgrammes.map((prog, i) => (
          <div key={i} className="programme-card">
            <div className="programme-image">
              <img src={prog.image} alt={prog.title} />
            </div>
            <div className="programme-info">
              <h3>{prog.title}</h3>
              <p className="provider">Provider: {prog.provider}</p>
              <p className="provider">
              Site Access:{" "}
              <a href={prog.link} target="_blank" rel="noopener noreferrer">
              {prog.link}
             </a>
             </p>

              <div className="description">{formatDescription(prog.description)}</div>
              {prog.price && <p className="price">Fee: {prog.price} (USD)</p>}

              {categories.find(c => c.id === selectedCategory).paid
                ? <button
                    type="button"
                    className="programme-link"
                    onClick={() => openModal(prog)}
                  >
                    Book / Enquire
                  </button>
                : <a
                    href={prog.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="programme-link"
                  >
                    Learn More
                  </a>
              }
            </div>
          </div>
        ))}
        <ChatBot />
      </div>

      {/* Book / Enquire Modal */}
      {modalContent && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Book {modalContent.title}</h2>
            </div>
            <button className="modal-close" onClick={closeModal}>×</button>
            
            <div className="modal-contact-info">
              {/* Nairobi */}
              <div className="contact-item">
                <span className="contact-icon"><img src={locationIcon} alt="" className="icon" /></span>
                <div>
                  <strong>Nairobi Office:</strong><br/>
                  ABC Place, Waiyaki Way, Nairobi, Kenya
                </div>
              </div>
              {/* Accra */}
              <div className="contact-item">
                <span className="contact-icon"><img src={locationIcon} alt="" className="icon" /></span>
                <div>
                  <strong>Accra Office:</strong><br/>
                  Marlin House, 13 Yiyiwa Dr, Accra, Ghana
                </div>
              </div>
              {/* Email */}
              <div className="contact-item">
                <span className="contact-icon"><img src={mailIcon} alt="" className="icon" /></span>
                <div>
                  <strong>Email:</strong><br/>
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => {
                      const program = modalContent;
                      const email = 'go-fmafricaprivateen@kpmg.com';
                      const cc    = 'privateenterprise@kpmg.co.ke,';
                      const subject = `Enquiry about ${program.title}`;
                      const body = `Hello KPMG Team,

I would like to inquire about the following program:

Program Title: ${program.title}
Provider: ${program.provider}
${program.price ? `Price: ${program.price}\n` : ''}

Please provide more information about:
[ ] Schedule availability
[ ] Payment options
[ ] Certification details
[ ] Customization options

Additional notes:
__________________________________________

Best regards,
[Your Full Name]
[Your Company Name]
[Your Contact Information]`;

                     const params = `subject=${encodeURIComponent(subject)}&cc=${encodeURIComponent(cc)}&body=${encodeURIComponent(body)}`;

const mailtoLink = `mailto:${encodeURIComponent(email)}?${params}`;

if (navigator.userAgent.includes('Outlook')) {
  window.open(
    `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(email)}&${params}`,
    '_blank'
  );
} else if (window.location.hostname.includes('mail.google')) {
  window.open(
    `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}&${params}`,
    '_blank'
  );
} else {
  window.location.href = mailtoLink;
}
                    }}
                  >
                    Send Inquiry Email
                  </button>
                </div>
              </div>
            </div>

            {/* Program details */}
            <div className="program-details">
              <h4>Program Summary</h4>
              <p><strong>Title:</strong> {modalContent.title}</p>
              <p><strong>Provider:</strong> {modalContent.provider}</p>
              {modalContent.price && (
                <p><strong>Investment:</strong> {modalContent.price}</p>
              )}
              <p><strong>Description:</strong> {modalContent.description}</p>
            </div>

            <div className="modal-footer">
              💡 This email template is pre-filled with program details. 
              Please customize the checkboxes and additional notes as needed.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProgrammesPage;
